import { Injectable, signal } from '@angular/core';
import { AssignmentDetails } from '../../../../types';

@Injectable()
export class AssignmentDetailsStore {
  private readonly _details = signal<AssignmentDetails | undefined>(undefined);
  public readonly details = this._details.asReadonly();

  set(details: AssignmentDetails) {
    this._details.set(details);
  }
}
